import { forwardRef, useMemo } from "react";

import { FormLabel, TablePagination } from "@mui/material";

import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { StyledDataGrid } from "../../../../../../common/components/styled_data_grid";
import { GenerateInformacoesColumnDefinition } from "../columns/informacoes";
import { HeaderResponsavel } from "./headerResponsavel";
import { InformacoesPaginationStore } from "../../../hooks/Projeto_Informacao/pagination";
import { InformacoesLista } from "../../../../domain/models/informacoes_lista";


type Props = {
  loading: boolean;
  informacoes: InformacoesLista[];
  pagination: InformacoesPaginationStore;
  Filterinformacoes: string | null;
  Filterdata: Date | null;
  handleInformacoes: () => void;
  onActionEditar: (id: number | null, openState: boolean) => void;
  onActionDeletar: (id: number | null, openState: boolean) => void;
  onFilterinformacoesChange: (v: string) => void;
  onFilterDataChange: (v: Date | null) => void;
  onFilterClear: () => void;
};

export const InformacoesProjetoContent = forwardRef<HTMLButtonElement, Props>(
  (
    {
      loading,
      informacoes,
      pagination,
      Filterinformacoes,
      Filterdata,
      handleInformacoes,
      onActionDeletar,
      onActionEditar,
      onFilterinformacoesChange,
      onFilterDataChange,
      onFilterClear,
    }: Props,
    ref
  ) => {

    const columnsDefinitionResponsavel = useMemo(() => {
      return GenerateInformacoesColumnDefinition({
        onActionDeletar: onActionDeletar,
        onActionEditar: onActionEditar
      });
    }, [onActionDeletar, onActionEditar]);


    return (
      <>
        <div className="w-full flex flex-col gap-8 bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border border-border-light-mode dark:border-border-dark-mode mb-4">
          <div className="w-full justify-between flex gap-2">
            <FormLabel className="flex-shrink-0">Informações do Projeto</FormLabel>
            <div className="flex gap-2">
              <PrimaryButton
                className="!w-auto"
                startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                onClick={handleInformacoes}
              >
                Novo Item
              </PrimaryButton>
            </div>
          </div>

          <HeaderResponsavel
            informacoes={Filterinformacoes}
            data={Filterdata}
            onInformacoesChange={onFilterinformacoesChange}
            onDataChange={onFilterDataChange}
            onClear={onFilterClear}
          ></HeaderResponsavel>

          {/* 
          <StyledDataGrid
            autoHeight={true}
            height="60vh"
            tableName="Item Checklist"
            disableColumnMenu={false}
            showToolbar={true}
            disableRowSelectionOnClick={true}
            getRowId={(row: InformacoesLista) => row.IdInformacoes}
            columns={columnsDefinitionResponsavel}
            loading={loading}
            checkboxSelection={false}
            rows={informacoes}
            rowCount={pagination.totalItems}
            pageSizeOptions={[10, 25, 50, 100]}
            paginationMode="server"
            paginationModel={{
              page: pagination.page,
              pageSize: pagination.rowsPerPage,
            }}
            pinnedColumns={{
              right: ["IdInformacoes"],
            }}
          /> */}

          <StyledDataGrid
            autoHeight={true}
            tableName="Item Checklist"
            disableColumnMenu={false}
            showToolbar={true}
            disableRowSelectionOnClick={true}
            getRowId={(row: InformacoesLista) => row.IdInformacoes}
            columns={columnsDefinitionResponsavel}
            loading={loading}
            checkboxSelection={false}
            rows={informacoes}
            rowCount={pagination.totalItems}
            pageSizeOptions={[10, 25, 50, 100]}
            paginationMode="server"
            paginationModel={{
              page: pagination.page,
              pageSize: pagination.rowsPerPage,
            }}
            pinnedColumns={{
              right: ["IdInformacoes"],
            }}
          />


          <TablePagination
            component="div"
            count={pagination.totalItems}
            page={pagination.page - 1}
            onPageChange={(_, p) => { }}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={pagination.rowsPerPage}
            onRowsPerPageChange={(e) => { }}
          />

        </div>
      </>
    );
  },
);
